import React from 'react'
import type { CSSProperties } from 'react'
import styles from './FollowIcon.module.css'

type FollowIconProps = {
    iconStyle: CSSProperties
}

export const FollowIcon = ({ iconStyle }: FollowIconProps) => {
    return (
        <div className={styles.followIcon} style={iconStyle} aria-hidden="true">
            <img src="/entry_form_slide_app/common/followIcon.png" alt="" />
        </div>
    )
}
